import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Page::Intro />", {
  moduleName: "vagrant/templates/intro.hbs"
});